import type { CarrierDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Mail } from "lucide-react";
import { isChronopostELabel } from "../lib/chronopost.helpers";

// Rendered wherever a merchant picks between two carriers sharing the
// `chronopost` code, so the print-less one is never mistaken for the standard
// return service. Renders nothing for any other carrier.
export const ChronopostELabelBadge = ({ carrier }: { carrier: CarrierDto }) => {
  const t = useTranslation();

  if (!isChronopostELabel(carrier)) return null;

  return (
    <span
      title={t("carrier.eLabel.hint")}
      className="inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2.5 py-0.5 text-xs font-medium text-indigo-700 border border-indigo-200"
    >
      <Mail className="h-3 w-3" />
      {t("carrier.eLabel.badge")}
    </span>
  );
};
